import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import React from 'react';
import { getStyle } from './utils.es.js';

const Map = React.forwardRef((props, ref) => {
    const { address, zoom, commonStyle, id } = props, rest = __rest(props, ["address", "zoom", "commonStyle", "id"]);
    return (jsx(Wrapper, Object.assign({ ref: ref, id: id, commonStyle: commonStyle }, rest, { children: jsx("iframe", { title: "map", width: "100%", height: "100%", frameBorder: 0, scrolling: "no", marginHeight: 0, marginWidth: 0, src: `https://maps.google.com/maps?q=${encodeURI(address || '')}&z=${zoom || 14}&ie=UTF8&iwloc=B&output=embed` }) })));
});
const Wrapper = styled.div(({ commonStyle }) => `
    ${getStyle(commonStyle)}`);
Map.displayName = 'Map';

export { Map as M };
